<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
  .abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  .bizmoney-charge {
    position: relative;
    padding: 36px 60px 50px;
    text-align: center;
    h2 {
      font-size: 18px; margin-bottom: 50px;
    }
    a.close {
      position: absolute;
      display: block;
      width: 50px;
      height: 50px;
      top: 0;
      right: 0;
      font-size: 0;
      color: transparent;
      &::after {
        content: '';
        .abs-center;
        background-image: url(~@/assets/icon-close.png);
        width: 16px;
        height: 16px;
      }
    }
    .money {
      position: relative;
      border: 1px solid #dde1e3;
      background-color: #f5f9fc;
      border-radius: 3px;
      box-shadow: 0px 7px 10px 0 #f5f9fc;
      height: 70px;
      font-weight: bold;
      margin-bottom: 40px;
      &::before {
        content: '잔액';
        .abs-tcenter;
        left: 20px;
        line-height: 70px;
        font-size: 18px;
      }
      span {
        &::before {
          content: '₩ ';
        }
        font-size: 18px;
        .abs-tcenter;
        right: 20px;
      }
    }
  }

  .btns {
    display: flex;
    padding: 60px 0 0 0;
    margin: 0 -5px;
    button {
      flex: 1;
      color: #ff6c00;
      margin: 0 5px;
    }
    button.bonus {
      position: relative;
      height: 50px;
      &::after {
        content: 'BONUS';
        position: absolute;
        top: -10px;
        right: 25px;
        font-size: 11px;
        padding: 0 6px;
        border: 1px solid #7965ef;
        border-radius: 10px;
        color: #7965ef;
        background-color: #fff;
        line-height: 18px;
      }
    }
  }

  .el-dialog__header {
    text-align: center;
  }
</style>

<style lang="less">
  .bizmoney {
    .el-dialog__header {
      text-align: center;
      .el-dialog__title {
        position: relative;
        top: 27px;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
</style>


<template lang="pug">
  el-dialog.bizmoney(:visible="visible", :payData="payData" width="580px", title="비즈머니 충전", @close="close")
    .bizmoney-charge
      .money
        span {{ bizMoney | displayBizMoney }}
      el-table(
        ref="payTable",
        :data="tableData",
        border,
        highlight-current-row,
        align="center",
        class="table-type-2",
        @row-click="clickRow",
        @current-change="handleCurrentChange"
      )
        el-table-column(prop="priceText", label="결제금액 (vat 포함)", header-align="center", align="left", className="price")
        el-table-column(prop="bonusText", label="계좌이체 보너스 쿠폰", header-align="center", align="left", className="bonus")
        el-table-column(label="선택", align="center", width="100", className="radio")
          template(slot-scope="scope")
            el-radio(v-model="price", :label="scope.row.price")
      .btns
        el-tooltip(class="item", dffect="dark", content="카드결제시 보너스는 지급되지 않습니다.", placement="top")
          el-button(@click="payCard") 카드결제
        el-button.bonus(@click="payBank") #[span 가상계좌]
    form(name="paymentForm", accept-charset="euc-kr")
      input(name="allat_shop_id", type="hidden", value="sta1")
      input(name="allat_order_no", type="hidden", :value="payData.allat_order_no")
      input(name="allat_amt", type="hidden", :value="payData.allat_amt")
      input(name="allat_pmember_id", type="hidden", :value="payData.allat_pmember_id")
      input(name="allat_product_cd", type="hidden", :value="payData.allat_product_cd")
      input(name="allat_product_nm", type="hidden", :value="payData.allat_product_nm")
      input(name="allat_buyer_nm", type="hidden", :value="payData.allat_buyer_nm")
      input(name="allat_email_addr", type="hidden", :value="payData.allat_email_addr")
      input(name="allat_recp_nm", type="hidden", :value="payData.allat_recp_nm")
      input(name="allat_recp_addr", type="hidden", :value="payData.allat_recp_addr")
      input(name="shop_receive_url", type="hidden", :value="payData.shop_receive_url")
      input(name="allat_enc_data", type="hidden", :value="payData.allat_enc_data")
      input(name="allat_card_yn", type="hidden", :value="payData.allat_card_yn")
      input(name="allat_bank_yn", type="hidden", :value="payData.allat_bank_yn")
      input(name="allat_vbank_yn", type="hidden", :value="payData.allat_vbank_yn")
      input(name="allat_tax_yn", type="hidden", :value="payData.allat_tax_yn")
      input(name="allat_cash_yn", type="hidden", :value="payData.allat_cash_yn")
      input(name="allat_real_yn", type="hidden", :value="payData.allat_real_yn")
      input(name="allat_test_yn", type="hidden", :value="payData.allat_test_yn")
</template>

<script>
import { mapState } from 'vuex';

const DEFUALT_PAY_DATA = {
  // 올앳 상점 ID
  allat_shop_id: 'sta1',
  // 주문 번호
  allat_order_no: '',
  // 결제 금액
  allat_amt: '',
  // 회원 ID
  allat_pmember_id: '',
  // 상품 코드
  allat_product_cd: 'BIZMNY',
  // 상품 명
  allat_product_nm: '스타일닷컴 비즈머니',
  // 결제자 성명
  allat_buyer_nm: '',
  // 결제정보 수신 이메일
  allat_email_addr: '',
  // 수취인 성명
  allat_recp_nm: '',
  // 수취인 주소
  allat_recp_addr: '서울시 송파구 송파대로 201',
  // 인증정보 수신 URL
  shop_receive_url: process.env.VUE_APP_SHOP_RECEIVE_URL,
  // 주문정보 암호화 필드
  allat_enc_data: '',

  // 신용카드 결제 사용 여부
  allat_card_yn: 'N',
  // 실시간 계좌이체
  allat_bank_yn: 'N',
  // 가상계좌 결제 사용 여부
  allat_vbank_yn: 'N',
  // 과세여부
  allat_tax_yn: 'Y',
  // 현금 영수증 발급 여부
  allat_cash_yn: 'N',
  // 상품 실물 여부
  allat_real_yn: 'N',
  // 결제 테스트 여부
  allat_test_yn: process.env.VUE_APP_PAYMENT_TEST,
};

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    bizMoney: {
      type: Number,
      default: 0,
    },
  },
  filters: {
    displayBizMoney(value) {
      return value.toLocaleString();
    },
  },
  computed: {
    ...mapState({
      me: state => state.me,
    }),
  },
  mounted() {
    this.payDataCopy = this.payData;
    window.resultSubmit = (allatResultCd, allatResultMsg, allatEncData) => {
      window.AllatPay_Closechk_End();
      if (allatResultCd !== '0000') {
        // 결제 실패
        setTimeout(() => {
          this.$alert(`${allatResultCd} : ${allatResultMsg}`, {
            confirmButtonText: '확인',
          });
        }, 200);
      } else {
        // 결제 성공
        this.paymentResult(allatEncData);
      }
    };
  },
  methods: {
    clickRow(row) {
      this.price = row.price;
      this.bonus = row.bonus;
    },
    close(type) {
      this.$emit('close', type);

      this.payData = DEFUALT_PAY_DATA;
      this.price = 0;
      this.bonus = 0;
      this.payData.allat_card_yn = 'N';
      this.payData.allat_vbank_yn = 'N';
      this.$refs.payTable.setCurrentRow();
    },

    // 결제 완료
    async paymentResult(allatEncData) {
      this.payData.allat_enc_data = allatEncData;
      const paymentResult = await this.$http.post('/api/mkc/v1/allat-payment-submit', {
        allat_enc_data: allatEncData,
        allat_amt: this.payData.allat_amt,
      });
      if (paymentResult.status === 200) {
        let paymentResultAlert = '';
        if (this.payData.allat_card_yn === 'Y') {
          paymentResultAlert = '결제가 완료 되었습니다.';
        } else if (this.payData.allat_vbank_yn === 'Y') {
          paymentResultAlert = '가상계좌 입금시 비즈머니가 충전됩니다.';
        }
        this.$alert(paymentResultAlert, {
          confirmButtonText: '확인',
          callback: () => {
            this.close(this.payData.allat_vbank_yn);
          },
        });
      }
    },

    // 카드결제
    payCard() {
      this.payData.allat_card_yn = 'Y';
      this.payData.allat_vbank_yn = 'N';
      this.payCommon();
    },

    // 가상계좌 결제
    payBank() {
      this.payData.allat_card_yn = 'N';
      this.payData.allat_vbank_yn = 'Y';
      this.payCommon();
    },

    // 결제 공통
    async payCommon() {
      if (this.price < 1) {
        this.$alert('결제금액을 선택해 주세요.', {
          confirmButtonText: '확인',
        });
        return;
      }
      this.payData.allat_amt = this.price;
      this.payData.allat_pmember_id = this.me.id;
      this.payData.allat_buyer_nm = this.me.name;
      this.payData.allat_email_addr = this.me.email;
      this.payData.allat_recp_nm = this.me.name;

      const orderNumber = await this.$http.get('/api/mkc/v1/order-number');
      this.payData.allat_order_no = orderNumber.data.data;

      setTimeout(() => {
        window.AllatPay_Approval(document.forms.paymentForm);
        window.AllatPay_Closechk_Start();
      }, 1000);
    },

    handleCurrentChange(val) {
      this.currentRow = val;
    },
  },
  data() {
    return {
      // 테이블 데이터
      tableData: [
        {
          priceText: '₩ 330,000',
          bonusText: '₩ 0',
          price: 330000,
          bonus: 0,
        },
        {
          priceText: '₩ 550,000',
          bonusText: '₩ 10,000',
          price: 550000,
          bonus: 10000,
        },
        {
          priceText: '₩ 1,100,000',
          bonusText: '₩ 50,000',
          price: 1100000,
          bonus: 50000,
        },
        {
          priceText: '₩ 3,300,000',
          bonusText: '₩ 200,000',
          price: 3300000,
          bonus: 200000,
        },
        {
          priceText: '₩ 5,500,000',
          bonusText: '₩ 400,000',
          price: 5500000,
          bonus: 400000,
        },
        {
          priceText: '₩ 11,000,000',
          bonusText: '₩ 1,000,000',
          price: 11000000,
          bonus: 1000000,
        },
      ],
      price: 0,
      bonus: 0,
      currentRow: null,

      payDataCopy: {},

      payData: DEFUALT_PAY_DATA,
    };
  },
};
</script>
